import React, { useEffect, useState } from 'react';
import '../styles/SuccessIndicator.css';

const SuccessIndicator = ({ show, onAnimationComplete }) => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    if (show) {
      setVisible(true);
      
      // Set a timeout to hide the indicator after animation completes
      const timer = setTimeout(() => {
        setVisible(false);
        if (onAnimationComplete) {
          onAnimationComplete();
        }
      }, 800); // Animation duration
      
      return () => clearTimeout(timer);
    }
  }, [show, onAnimationComplete]);
  
  if (!visible) return null;
  
  return (
    <div className="success-indicator-overlay">
      <div className="success-indicator">
        <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
          <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
      </div>
    </div>
  );
};

export default SuccessIndicator;
